import React from "react";
import { Link } from "react-router-dom";

export function Logo({ compact = false, className = "" }) {
  return (
    <Link to="/" className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      {!compact && <img src="/logo-full.png" alt="GjejShqip – Gjej çka të duhet." style={{ height: 38, width: "auto" }} draggable={false} />}
      {compact && <img src="/logo-icon.png" alt="GjejShqip" style={{ height: 38, width: 38 }} draggable={false} />}
    </Link>
  );
}

export default Logo;
